import React from 'react'
const AuthCenterContext = React.createContext(null)
export default AuthCenterContext